import { useMemo } from 'react'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'
import { useNumericParams } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import useProviderPriceList from '@hooks/useProviderPriceList'

import PriceListManager from '@components/PriceListManager'

import PageLayout from '../../components/PageLayout'

const Items = () => {
  const { providerPriceListId } = useNumericParams()

  const { viewMode } = parsePermittedQueryParams(getQueryParamsFromHash(), ['viewMode'])

  const providerPriceListPayload = useProviderPriceList({ id: providerPriceListId })

  const pageContext = useMemo(() => ({
    callbacks: {
      syncChangesToForks: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      {/*
       // @ts-expect-error TS2322 */}
      <PageLayout providerPriceListPayload={providerPriceListPayload} activeTabBarItemKey={viewMode} showSavedButton>
        <PriceListManager
          providerPriceListPayload={providerPriceListPayload}
          // @ts-expect-error TS2322
          viewMode={viewMode}
        />
      </PageLayout>
    </PageContext.Provider>
  )
}

export default Items
